import { useState, useEffect } from "react";

const KEY = "sns_token";

function parseToken(token) {
  try {
    const parts = token.split(".");
    const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const decoded = atob(b64);
    const text = decodeURIComponent(
      decoded.split("").map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)).join("")
    );
    return JSON.parse(text);
  } catch {
    return null;
  }
}

export function useAuth() {
  const [token, setToken] = useState(() => localStorage.getItem(KEY));
  const [user, setUser] = useState(() => {
    const t = localStorage.getItem(KEY);
    return t ? parseToken(t) : null;
  });

  function login(newToken) {
    localStorage.setItem(KEY, newToken);
    setToken(newToken);
    setUser(parseToken(newToken));
  }

  function logout() {
    localStorage.removeItem(KEY);
    setToken(null);
    setUser(null);
  }

  return { token, user, login, logout };
}
